import { render, staticRenderFns } from "./JoinedSchoolItem.vue?vue&type=template&id=e741302e&scoped=true&"
import script from "./JoinedSchoolItem.vue?vue&type=script&lang=js&"
export * from "./JoinedSchoolItem.vue?vue&type=script&lang=js&"
import style0 from "./JoinedSchoolItem.vue?vue&type=style&index=0&id=e741302e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e741302e",
  null
  
)

export default component.exports